import { getStatusColor } from '@/utils';
import { Layer, Source } from 'react-map-gl/maplibre';

export function ExternalVehiclesSource({ id, data, visibility = 'visible' }) {
  return (
    <Source id={id} type="geojson" data={data}>
      <Layer
        id={`${id}-shape-layer`}
        type="symbol"
        layout={{
          'icon-image': 'ir3-teardrop',
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.125, 12, 1],
          'icon-rotate': ['get', 'headingDegrees'],
          visibility,
        }}
        paint={{
          'icon-color': [
            'match',
            ['get', 'status'],
            'EMERGENCY_EQUIPMENT_ON',
            getStatusColor('EMERGENCY_EQUIPMENT_ON'),
            'IGNITION_OFF',
            getStatusColor('IGNITION_OFF'),
            'IGNITION_ON',
            getStatusColor('IGNITION_ON'),
            'MALFUNCTION_INDICATOR_LIGHT_ON',
            getStatusColor('MALFUNCTION_INDICATOR_LIGHT_ON'),
            getStatusColor('DEFAULT'),
          ],
          'icon-halo-color': '#fff',
          'icon-halo-width': 1,
        }}
      />
      <Layer
        id={`${id}-symbol-layer`}
        type="symbol"
        layout={{
          'icon-image': 'ir3-external-car',
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.075, 12, 0.6],
          visibility,
        }}
        paint={{
          'icon-color': '#fff',
        }}
      />
    </Source>
  );
}
